import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Reveal } from '../components/ui/Reveal';
import { CtaBanner } from '../components/ui/CtaBanner';
import { SERVICE_GROUPS, INDUSTRIES } from '../data/content';
import { IMAGES } from '../data/images';
import { useLanguage } from '../i18n/LanguageContext';
export function Services() {
  const {
    lang,
    p
  } = useLanguage();
  const s = p.services;
  return <>
      <Seo title={s.seo.title} description={s.seo.description} data-id="element-503" data-mp="b2q6joq19vul" />
      <PageHero eyebrow={s.hero.eyebrow} title={s.hero.title} description={s.hero.description} breadcrumb={s.hero.breadcrumb} image={IMAGES.reception} data-id="element-504" data-mp="64g917gu6j5t" />

      <div className="w-full bg-white" data-id="element-505" data-mp="27wulhr0m2veu">
        {SERVICE_GROUPS.map((group, gi) => {
        const copy = group.copy[lang];
        return <section key={group.copy.en.title} className={`w-full py-24 lg:py-32 ${gi % 2 === 1 ? 'bg-mist' : 'bg-white'}`} aria-labelledby={`group-${gi}`} data-id="element-506" data-mp="16qnqi2yzrezv" data-mpi={gi}>
              <div className="mx-auto max-w-container px-6" data-id="element-507" data-mp="1fnenchldaxvi">
                <Reveal data-id="element-508" data-mp="1kh1009rj71rb">
                  <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-509" data-mp="1khivh46ddby6">
                    <div className="max-w-2xl" data-id="element-510" data-mp="1phex4wrlgrak">
                      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-gold" data-id="element-511" data-mp="1udm5ew7gqevo">
                        <group.Icon className="h-6 w-6" aria-hidden="true" data-id="element-512" data-mp="1zejmt6knf4w4" />
                      </span>
                      <h2 id={`group-${gi}`} className="mt-6 font-display text-3xl font-medium leading-tight text-navy sm:text-4xl" data-id="element-513" data-mp="23dsfs97v6yqm">
                        {copy.title}
                      </h2>
                      <p className="mt-5 text-base leading-relaxed text-charcoal-light" data-id="element-514" data-mp="1cbgdo5i0guyu">
                        {copy.intro}
                      </p>
                    </div>
                    <p className="font-display text-6xl font-light text-navy-100" data-id="element-515" data-mp="17f80uyradduu">
                      {String(gi + 1).padStart(2, '0')}
                    </p>
                  </div>
                </Reveal>

                <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-516" data-mp="1vakljaxtgiox">
                  {copy.items.map((item, i) => <Reveal as="li" key={item.name} delay={i * 0.04} data-id="element-517" data-mp="1qapvtaps1z5g" data-mpi={i}>
                      <div className="group flex h-full gap-4 rounded-2xl border border-navy-100 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-lift" data-id="element-518" data-mp="250dvk7ib8pr2">
                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy-50 text-navy transition-colors duration-300 group-hover:bg-gold group-hover:text-navy" data-id="element-519" data-mp="2e0k5xkipp9m0">
                          <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-520" data-mp="2snr56syu4j52" />
                        </span>
                        <div data-id="element-521" data-mp="2xlsrrnvgz0la">
                          <h3 className="font-display text-lg font-semibold leading-snug text-navy" data-id="element-522" data-mp="2xl1552juod75">
                            {item.name}
                          </h3>
                          <p className="mt-2 text-sm leading-relaxed text-charcoal-light" data-id="element-523" data-mp="2nnmob1u0lmeb">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </Reveal>)}
                </ul>
              </div>
            </section>;
      })}
      </div>

      <section className="w-full bg-navy py-24 lg:py-28" data-id="element-524" data-mp="24xww8mhmzeq3">
        <div className="mx-auto max-w-container px-6" data-id="element-525" data-mp="24wdgqy3t17pd">
          <SectionHeading eyebrow={s.sectorEyebrow} title={s.sectorTitle} align="center" tone="light" data-id="element-526" data-mp="1qyf5w2ooztem" />
          <ul className="mx-auto mt-14 flex max-w-4xl flex-wrap justify-center gap-3" data-id="element-527" data-mp="1nx2hx4h4xkxz">
            {INDUSTRIES.map((industry, i) => <Reveal as="li" key={industry.name.en} delay={i * 0.03} data-id="element-528" data-mp="1iz0nxoi6817q" data-mpi={i}>
                <span className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm text-navy-100/80 transition-colors duration-300 hover:border-gold/50 hover:text-gold" data-id="element-529" data-mp="1e70tgbkve0ij">
                  <industry.Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-530" data-mp="157403wnjcdh5" />
                  {industry.name[lang]}
                </span>
              </Reveal>)}
          </ul>
          <Reveal delay={0.2} data-id="element-531" data-mp="v853xdjyiab1">
            <div className="mt-14 text-center" data-id="element-532" data-mp="v96bh81rkeo0">
              <Link to="/how-it-works" className="group inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-gold transition-colors hover:text-gold-light" data-id="element-533" data-mp="r6t82qahosue">
                {s.processLink}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-534" data-mp="2lllzed4caxgj" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBanner data-id="element-535" data-mp="h3xobqyz32qk" />
    </>;
}